import { render } from "./UnarchivedIcon.vue?vue&type=template&id=ed3e1ede"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__